/** @format */

import React, { useEffect } from "react";
import { Outlet, useLocation, useSearchParams } from "react-router-dom";
import { loadFlags } from "./features/featureFlag/featureFlagSlice";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { useAnalytics } from "use-analytics";
import Header from "./features/header/Header";
import Notifications from "./features/notifications/Notifications";
import { Buffer } from "buffer";
import { setUserToken, UserToken } from "./auth/authSlice";
import useDocumentTitle from "./utils/hooks/useDocumentTitle";
import "./App.scss";
import { selectIsPrintable } from "./features/printable/printableSlice";

const App: React.FC = () => {
  const { page } = useAnalytics();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const isPrintable = useAppSelector(selectIsPrintable());

  const [searchParams, setSearchParams] = useSearchParams();

  useDocumentTitle("site title");

  useEffect(() => {
    const tkid = searchParams.get("tkid");
    if (!!tkid) {
      const tokenKeys = ["expires", "refreshToken", "token", "service"];
      const token: UserToken = JSON.parse(
        Buffer.from(tkid, "base64").toString("utf-8"),
      );

      if (
        Object.keys(token).every((key) => tokenKeys.includes(key)) &&
        token.expires > Date.now()
      ) {
        dispatch(setUserToken(token)); // Update user token with new details
      }

      searchParams.delete("tkid");
      setSearchParams(searchParams, { replace: true });
    }
  }, [dispatch, location, searchParams, setSearchParams]);

  useEffect(() => {
    dispatch(loadFlags());
  }, [dispatch]);

  useEffect(() => {
    page();
  }, [page, location]);

  useEffect(() => {
    if (document.getElementsByClassName("page-container")?.[0] !== undefined)
      document.getElementsByClassName("page-container")[0].scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <div
        id="app-container"
        className={`${isPrintable ? "h-100 d-block" : ""}`}
      >
        <Header />
        <Notifications />
        <Outlet />
      </div>
    </>
  );
};

export default App;
